import { ShiftSlot } from '../../../shared/types/shiftTypes.ts';
import { PageDisplayOption } from '../../types/pageDispalyOptions.ts';
import { OeeComponent, OeeGraphValueType } from '../../utils/ooeGraphValueType.ts';


export interface TimeFrameOption {
    key: number;
    label: string;
    days?: number;
    hours?: number;
}

export const timeFrameOptions: TimeFrameOption[] = [
    { key: 0, label: '8 hours', hours: 8 },
    { key: 1, label: '1 days', days: 1 },
    { key: 2, label: '2 days', days: 2 },
    { key: 3, label: '3 days', days: 3 },
    { key: 4, label: '4 days', days: 4 },
    { key: 5, label: '5 days', days: 5 },
    { key: 6, label: '6 days', days: 6 },
    { key: 7, label: '7 days', days: 7 },
];


export interface LiveGraphSettings {
    visibleShifts: ShiftSlot[];
    timeFrame: TimeFrameOption;
    excludeWeekends: boolean;
    smoothingAmount: number;
    resolution: 'halfHour' | 'hour' | 'shift';
    valueType: OeeGraphValueType;
    oeeComponents: OeeComponent[];
    pageDisplay: PageDisplayOption;
}
